import { useEffect, useRef } from 'react'

import { useProgress } from 'hooks/useProgress'
import { Screenshot } from 'screens/VirtualMarketerOnboarding/BrandProfileWebsite/Screenshot'
import { LoadingProgresses } from 'screens/VirtualMarketerOnboarding/Loading/LoadingProgresses'

interface Props {
  url?: string
  handleBack: () => void
  cancelOnError?: boolean
  finishedLoading?: boolean
}

export const LoadingText = ({ url, handleBack, cancelOnError, finishedLoading }: Props) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const {
    start: startThree,
    isRunning: isRunningThree,
    progress: progressThree,
  } = useProgress({ linearProgress: true, speed: 35, immediateComplete: true })
  const {
    start: startTwo,
    isRunning: isRunningTwo,
    progress: progressTwo,
  } = useProgress({ linearProgress: true, speed: 35, immediateComplete: true, onDone: startThree })
  const {
    start: startOne,
    isRunning: isRunningOne,
    progress: progressOne,
  } = useProgress({ linearProgress: true, speed: 75, immediateComplete: true, onDone: startTwo })

  if (!isRunningOne && progressOne === 0) {
    startOne()
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  const progresses = [
    {
      title: 'Analyzing your website',
      isRunning: isRunningOne,
      percentComplete: finishedLoading ? 100 : progressOne,
      element: <Screenshot url={url} handleBack={handleBack} cancelOnError={cancelOnError} />,
      lineHeight: 220,
    },
    {
      title: 'Locating business',
      isRunning: isRunningTwo,
      percentComplete: finishedLoading ? 100 : progressTwo,
    },
    {
      title: 'Looking for competitors',
      isRunning: isRunningThree && !finishedLoading,
      percentComplete: finishedLoading ? 100 : progressThree,
    },
  ]

  return <LoadingProgresses progresses={progresses} finishedLoading={finishedLoading} />
}
